import React, { useState, useEffect } from "react";
import LoggingService from "../../services/LoggingService";
import "../../styles/Logs.css";

const Logs = () => {
  const [logs, setLogs] = useState({});
  const [expandedUsers, setExpandedUsers] = useState({});
  const [expandedYears, setExpandedYears] = useState({});
  const [expandedMonths, setExpandedMonths] = useState({});
  const [expandedDates, setExpandedDates] = useState({});

  useEffect(() => {
    const storedLogs = LoggingService.getLogs();
    console.log("Fetched logs:", storedLogs);
    
    // Group logs by user, year, month, and date
    const groupedLogs = {};
    Object.entries(storedLogs).forEach(([email, userLogs]) => {
      groupedLogs[email] = userLogs.reduce((acc, log) => {
        const [date] = log.timestamp.split(" "); // Extract date part
        const [day, month, year] = date.split(".");
        
        if (!acc[year]) acc[year] = {};
        if (!acc[year][month]) acc[year][month] = {};
        if (!acc[year][month][date]) acc[year][month][date] = [];
        
        acc[year][month][date].push(log);
        return acc;
      }, {});
    });
    
    setLogs(groupedLogs);
  }, []);

  const toggleUserLogs = (email) => {
    setExpandedUsers((prev) => ({ ...prev, [email]: !prev[email] }));
  };

  const toggleYearLogs = (email, year) => {
    setExpandedYears((prev) => ({
      ...prev,
      [email]: { ...prev[email], [year]: !prev[email]?.[year] }
    }));
  };

  const toggleMonthLogs = (email, year, month) => {
    setExpandedMonths((prev) => ({
      ...prev,
      [email]: {
        ...prev[email],
        [`${year}-${month}`]: !prev[email]?.[`${year}-${month}`]
      }
    }));
  };

  const getMonthName = (month) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return months[parseInt(month) - 1];
  };

  const toggleDateLogs = (email, year, month, date) => {
    setExpandedDates((prev) => ({
      ...prev,
      [email]: {
        ...prev[email],
        [`${year}-${month}-${date}`]: !prev[email]?.[`${year}-${month}-${date}`]
      }
    }));
  };

  return (
    <div className="logs-container">
      <h2>Logs</h2>
      {Object.keys(logs).length === 0 ? (
        <p>No logs available.</p>
      ) : (
        Object.entries(logs).map(([email, yearLogs]) => (
          <div key={email} className="log-entry">
            <div className="log-email" onClick={() => toggleUserLogs(email)}>
              {email} <span>{expandedUsers[email] ? "▲" : "▼"}</span>
            </div>
            {expandedUsers[email] && (
              <div className="log-years">
                {Object.keys(yearLogs).sort((a, b) => b - a).map((year) => (
                  <div key={year} className="log-year">
                    <div className="log-year-header" onClick={() => toggleYearLogs(email, year)}>
                      {year} <span>{expandedYears[email]?.[year] ? "▲" : "▼"}</span>
                    </div>
                    {expandedYears[email]?.[year] && (
                      <div className="log-months">
                        {Object.keys(yearLogs[year]).sort((a, b) => b - a).map((month) => (
                          <div key={month} className="log-month">
                            <div 
                              className="log-month-header" 
                              onClick={() => toggleMonthLogs(email, year, month)}
                            >
                              {getMonthName(month)} <span>{expandedMonths[email]?.[`${year}-${month}`] ? "▲" : "▼"}</span>
                            </div>
                            {expandedMonths[email]?.[`${year}-${month}`] && (
                              <ul className="log-list">
                                {Object.entries(yearLogs[year][month])
                                  .sort(([dateA], [dateB]) => new Date(dateB.split('.').reverse().join('-')) - new Date(dateA.split('.').reverse().join('-')))
                                  .map(([date, dayLogs]) => (
                                    <li key={date} className="log-date-group">
                                      <div 
                                        className="log-date-header" 
                                        onClick={() => toggleDateLogs(email, year, month, date)}
                                      >
                                        {date} <span>{expandedDates[email]?.[`${year}-${month}-${date}`] ? "▲" : "▼"}</span>
                                      </div>
                                      {expandedDates[email]?.[`${year}-${month}-${date}`] && (
                                        <ul className="log-items">
                                          {dayLogs.map((log, index) => (
                                            <li key={index} className="log-item">
                                              {log.timestamp.split(' ')[1]}: {log.message}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </li>
                                  ))}
                              </ul>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default Logs;
